<template>
  <div>
    <van-overlay :show="popup.visible" @click="clickOverlay" :lock-scroll="false" z-index="3000">
      <div class="popup-box">
        <!-- 关注公众号弹窗 -->
        <scan-code v-if="popup.status === 'code'" />

        <!-- 领取红包弹窗 -->
        <receive-envelop v-if="popup.status === 'envelop'" :popup="popup" :room="room" :user="user" />

        <!-- 领取奖品弹窗 -->
        <prize-draw v-if="popup.status === 'gifts'" :popup="popup" :room="room" :user="user" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { filterPicture } from '@/filters'

import ScanCode from './scan-code'
import PrizeDraw from './prize-draw'
import ReceiveEnvelop from './receive-envelop'

export default {
  components: { ScanCode, PrizeDraw, ReceiveEnvelop },

  computed: {
    ...mapState({
      user: (state) => state.user,
      popup: (state) => state.popup,
      room: (state) => state.room,
    })
  },

  methods: {
    clickOverlay () {
      if (this.popup.status === 'envelop' || this.popup.status === 'gifts') return

      this.$store.commit('changePopupVisible', { visible: false })
    },

    goToCoupons () {
      this.$store.commit('closePopup')
      this.$router.push({ path: '/coupons' })
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-box {
  width: 6.35rem;
  .popup-close {
    z-index: 99;
    text-align: right;
    img {
      width: 30px;
    }
  }
}
</style>